import React from 'react';
import styled from 'styled-components';
import { Card, sa } from '../../../components/superAdminUi';

// At-a-glance panel for the school wizard, on the shared Super Admin design system: the school
// facts, the subscription headline and the product count.
const RailCard = styled(Card)`
  position: sticky;
  top: 16px;
  font-family: ${sa.font.family};
`;

const RailHeading = styled.div`
  font-weight: ${sa.font.bold};
  font-size: 16px;
  color: ${sa.color.text};
  margin-bottom: 16px;
`;

const RailSection = styled.div`
  & + & {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${sa.color.stroke};
  }
`;

const RailLabel = styled.div`
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-size: 11px;
  font-weight: ${sa.font.bold};
  color: ${sa.color.textGray};
  margin-bottom: 8px;
`;

const FactRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
`;

const FactLabel = styled.span`
  font-size: 13px;
  color: ${sa.color.textGray};
`;

const FactValue = styled.span`
  font-size: 13px;
  font-weight: ${sa.font.semibold};
  color: ${sa.color.text};
  text-align: right;
`;

const CountPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: ${sa.radius.pill};
  background: ${sa.color.schoolBg};
  color: ${sa.color.blue};
  font-size: 12px;
  font-weight: ${sa.font.bold};
`;

const Fact = ({ label, value }) => (
  <FactRow>
    <FactLabel>{label}</FactLabel>
    <FactValue>{value || '—'}</FactValue>
  </FactRow>
);

const subscriptionTotal = (values) => {
  const year1 = parseFloat(values.Year1Cost || 0);
  const year2 = parseFloat(values.Year2Cost || 0);
  const year3 = parseFloat(values.Year3Cost || 0);
  const discount = parseFloat(values.Discount || 0);
  const subtotal = year1 + year2 + year3 - discount;
  const vat = subtotal * (parseFloat(values.VatPercentApplied || 0) / 100);
  return (subtotal + vat).toFixed(2);
};

export default function SummaryRail({ values = {} }) {
  const products = values.products || [];
  return (
    <RailCard>
      <RailHeading>Summary</RailHeading>

      <RailSection>
        <RailLabel>School</RailLabel>
        <Fact label="School" value={values.Name} />
        <Fact label="URN" value={values.Urn} />
        <Fact label="Type" value={values.SchoolType} />
        <Fact label="Country" value={values.Country} />
      </RailSection>

      <RailSection>
        <RailLabel>Subscription</RailLabel>
        <Fact label="Term" value={values.SubscriptionTerm ? `${values.SubscriptionTerm} year(s)` : ''} />
        <Fact label="Total" value={`£${subscriptionTotal(values)}`} />
      </RailSection>

      <RailSection>
        <RailLabel>Products</RailLabel>
        <CountPill>{products.length} product(s)</CountPill>
      </RailSection>
    </RailCard>
  );
}
